import * as CONSTANTS from "../constants/constants";
export const GetFileFromServer = (url: string | undefined) => {
    return CONSTANTS!.HOST!.slice(0, -1) + url;
};
